import React, { ReactElement } from 'react';
import Box from '../../components/Box/Box';

type TAccordionProps = {
  children?: ReactElement | ReactElement[];
  className?: string;
};

const Accordion = (props: TAccordionProps) => <Box {...props} as="div" name="Accordion" />;

export default Accordion;
